// extracted by mini-css-extract-plugin
export var brandColorStyle = "core-values-grid-module--brand-color-style--e235a";